<template>
  <div class="footer-layout">
    <router-view class="page" />
    
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
  name: 'Layout',
  components: {
    Footer
  }
}
</script>

<style lang="less" scoped>
  .footer-layout {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 120px);
    width: 100vw;
    overflow: hidden;
    .page {
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
</style>